import { render, staticRenderFns } from "./fileModel.vue?vue&type=template&id=3bef2369&scoped=true&"
import script from "./fileModel.vue?vue&type=script&lang=js&"
export * from "./fileModel.vue?vue&type=script&lang=js&"
import style0 from "./fileModel.vue?vue&type=style&index=0&id=3bef2369&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef2369",
  null
  
)

export default component.exports